import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { ErrorPage, LoadingCartFullPage } from 'src/components';
import { useCreateStripeCheckoutSession, useCurrentUser } from 'src/hooks';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This is your test public API key.
const stripePromise = loadStripe(
  process.env.NODE_ENV === 'development'
    ? 'pk_test_51N9IxtAhnRXcgePmeOWBW2hOtyzAyjUskSPw0fHcNlthkYHCJK33upz2MIRzr1Bo2k41EKmQSfaiPKJsxGNrbCPt0001CY7YeA'
    : 'pk_live_51N9IxtAhnRXcgePmwlMoxsWuj0aBy0RgiXPu5Gu8DHWGThC335yyBGBznVqam6R4kUr6T6pBFFUJy8EYlTmRiBdW007wt06Rmk',
);

export const Subscribe = () => {
  const { user } = useCurrentUser();
  const [showError, setShowError] = useState(false);
  const [errorCode, setErrorCode] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleError = (errorCode: string) => {
    setShowError(true);
    setErrorCode(errorCode);
  };

  const { mutate: createStripeCheckoutSession, isPending } =
    useCreateStripeCheckoutSession({
      setClientSecret,
      handleError,
    });

  useEffect(() => {
    const plan = searchParams.get('plan');
    const promoCode = searchParams.get('promo');

    if (!plan || (plan !== 'personal' && plan !== 'organization')) {
      navigate('/plus/upgrade');
    }

    createStripeCheckoutSession({
      plan: plan as 'personal' | 'organization',
      promoCode: promoCode || undefined,
    });
  }, [searchParams, navigate, createStripeCheckoutSession]);

  if (!user) {
    return <Navigate to='/login' />;
  }

  return (
    <div id='checkout' className='py-4'>
      {isPending ? (
        <LoadingCartFullPage bgTransparent={true} />
      ) : showError ? (
        <ErrorPage errorCode={errorCode} />
      ) : clientSecret ? (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : (
        <ErrorPage errorCode='unknown_failure' />
      )}
    </div>
  );
};
